module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('figure', {
    staticClass: "custom-block-58f018ca1317b atavist-shared atavist-block atavist-block-align-center"
  }, [_c('img', {
    staticStyle: {
      "width": "600px",
      "height": "600px"
    },
    attrs: {
      "alt": "The Palphramonds Family Tree",
      "height": "600",
      "src": "images/scale1920x1200palphramonds-1531735640-50.jpg",
      "width": "600"
    }
  }), _vm._v(" "), _c('figcaption', [_c('span', {
    staticClass: "caption-body"
  }, [_vm._v("Characters who never appear directly in the narrative are in "), _c('i', {}, [_vm._v("italics")]), _vm._v(". Those who might possess the estate if Jeoffrey Huffam’s suppressed codicil were in force appear in "), _c('b', {}, [_vm._v("bold")]), _vm._v(" typeface. Those who might possess it if his purloined will were laid before the court are in "), _c('b', {}, [_vm._v("BOLD CAPITALS")]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstInSection"
  }, [_c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 66
// module chunks = 0